import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const SignupAgreement = ({ agreementAll, setAgreementAll }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const [agreementObj, setAgreementObj] = useState({
		policy: false,
		terms: false,
	});
	useEffect(() => {
		if (agreementAll) {
			setAgreementObj({
				policy: true,
				terms: true,
			});
		}
	}, [agreementAll]);

	useEffect(() => {
		if (!agreementObj.policy || !agreementObj.terms) {
			setAgreementAll(false);
		} else {
			setAgreementAll(true);
		}
	}, [agreementObj]);

	return (
		<>
			<p className={`signup-sub-title signup-border`}>약관동의</p>
			<div className={`signup-agreement-div`}>
				<button
					className={`signup-agreement-button signup-border`}
					onClick={() => {
						setAgreementAll(true);
					}}
				>
					<div className={`signup-agreement-title`}>
						<img
							src={`/assets/images/login/check${
								agreementAll ? "-active" : ""
							}.png`}
							alt={`동의사항 체크`}
							className={`check-img`}
						/>
						필수 항목 모두 동의
					</div>
				</button>
				<button
					className={`signup-agreement-button`}
					onClick={() =>
						setAgreementObj({
							...agreementObj,
							policy: !agreementObj?.policy,
						})
					}
				>
					<div className={`signup-agreement-title`}>
						<img
							src={`/assets/images/login/check${
								agreementObj.policy ? "-active" : ""
							}.png`}
							alt={`동의사항 체크`}
							className={`check-img`}
						/>
						개인정보처리방침(필수)
						<img
							src={`/assets/images/products/arrow.png`}
							alt={`화살표`}
							style={{
								height: "auto",
								width: "1em",
							}}
							onClick={(e) => {
								e.stopPropagation();
								window.open(
									`/together/channel/policy?id=${reduxChannel?.influencer_id}`
								);
							}}
						/>
					</div>
					<p className={`signup-agreement-description`}>
						회원님의 소중한 정보를 안전하게 지키겠다는 약속이에요.
					</p>
				</button>
				<button
					className={`signup-agreement-button`}
					onClick={() =>
						setAgreementObj({
							...agreementObj,
							terms: !agreementObj?.terms,
						})
					}
				>
					<div className={`signup-agreement-title`}>
						<img
							src={`/assets/images/login/check${
								agreementObj.terms ? "-active" : ""
							}.png`}
							alt={`동의사항 체크`}
							className={`check-img`}
						/>
						서비스 이용약관(필수)
						<img
							src={`/assets/images/products/arrow.png`}
							alt={`화살표`}
							style={{
								height: "auto",
								width: "1em",
							}}
							onClick={(e) => {
								e.stopPropagation();
								window.open(
									`/together/channel/terms?id=${reduxChannel?.influencer_id}`
								);
							}}
						/>
					</div>
					<p className={`signup-agreement-description`}>
						회원님에게 안정적인 서비스를 제공드리겠다는 약속이에요.
					</p>
				</button>
			</div>
		</>
	);
};
export default SignupAgreement;
